export class VisibilityObserver {
    constructor(options) {
        this.options = options;
        let targets = options.targets;
        if (targets instanceof NodeList || targets instanceof HTMLCollection) {
            targets = Array.from(targets);
        }
        if (!Array.isArray(targets)) {
            targets = [targets];
        }
        for (const target of targets) {
            this.observe(target);
        }
    }
    observe(target) {
        this.observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            if (entry.isIntersecting) {
                if ('ifIntoView' in this.options) {
                    this.options.ifIntoView.call(target);
                }
            }
            else {
                if ('ifOutOfView' in this.options) {
                    this.options.ifOutOfView.call(target);
                }
            }
        }, {
            rootMargin: `-${this.options.offset}px`
        });
        this.observer.observe(target);
    }
    destroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
// export default {VisibilityObserver, VisibilityObserverOptions}
export default VisibilityObserver;
